<template>
  <appointment-historical :get-appointment-history="getAppointmentHistory" />
</template>

<script>
import { AppointmentHistorical } from 'appointment-management';
import { getAppointmentHistory as _getAppointmentHistory } from '@/modules/provider/api';

export default {
  name: 'AppointmentHistoricalWrapper',
  components: {
    AppointmentHistorical,
  },
  methods: {
    getAppointmentHistory(clientAppointmentId) {
      return _getAppointmentHistory(clientAppointmentId);
    },
  },
};
</script>
